import { useNavigate } from 'react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addNotification } from 'notifications';
import { ensureCsrfToken } from 'api/csrf';
import { resetClientAuthState } from 'api/resetClientAuthState';
import { postLogout } from 'api/v1/requests/session';

export const useLogout = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const finishLogout = async () => {
    resetClientAuthState(queryClient);
    await ensureCsrfToken(true);
    navigate('/login', { replace: true });
  };

  return useMutation({
    mutationFn: postLogout,
    onSuccess: async () => {
      await finishLogout();
      addNotification('Вы вышли из аккаунта', 'success');
    },
    onError: async () => {
      // Always drop local session/cache so a subsequent login cannot reuse the prior account.
      await finishLogout();
      addNotification('Сессия сброшена локально. Если вход остается - обновите страницу.', 'info');
    },
  });
};
